import React, { useEffect, useState, useContext } from 'react'
import { AuthContext } from '../AuthContext'
import { Col, Row, Container } from 'react-bootstrap'
import ReactEcharts from 'echarts-for-react'
import Community from './Community'
import FanGrowth from './FanGrowth'
import AITeacher from '../AITeacher'
import { Helmet } from 'react-helmet'
// import axios from 'axios'
import { useAPI } from '../../hooks/useAPI'

const FansComponent = () => {
  const { currentUser, brandArr } = useContext(AuthContext)

  const GetLast = 'fanValue/v2/GetLast'

  const [data, setData] = useState({
    fans_grow_fb: 0,
    fans_grow_yt: 0,
    fans_accm_30d_yt: 0,
    ai_teacher_comment: '',
    fans_grow_ig: 0,
    fans_lost_30d_ig: 0,
    fans_lost_30d_fb: 0,
    fans_accm_30d_ig: 0,
    fans_accm_30d_fb: 0,
    fans_lost_30d_yt: 0,
    fans_grow_community: 0,
    fans_accm_7d_ig: 0,
    fans_accm_7d_fb: 0,
    fans_accm_7d_yt: 0,
  })

  const requestBody = currentUser.lv === 2 ? { kol_id: currentUser.kol_id } : {}

  const { fetchData } = useAPI({
    path: GetLast,
    requestBody: requestBody,
    initData: data,
    dependencies: [],
  })

  useEffect(() => {
    setData(fetchData)
  }, [fetchData])

  const growOption = {
    xAxis: {
      data: ['Facebook', 'Instagram', 'YouTube'],
    },
    yAxis: {
      name: '%',
    },
    legend: {},
    tooltip: { trigger: 'item', formatter: '{b} {c} %' },
    series: [
      {
        type: 'bar',
        data: brandArr.map((v) => {
          return {
            type: 'bar',
            name: v.title,
            value:
              data[`fans_grow_${v.brand}`] === '尚無資料'
                ? 0
                : data[`fans_grow_${v.brand}`],
            itemStyle: {
              color: v.color,
            },
          }
        }),
      },
    ],
  }
  return (
    <>
      <Helmet>
        <title>粉絲價值 | KOLSTAR</title>
      </Helmet>
      <main className="fans">
        <Container className="section1">
          <Row className="d-flex flex-column-reverse flex-md-row">
            <Col
              xs={12}
              md={5}
              className="flex-grow-1 text-nowrap overflowX my-auto"
            >
              <Community data={data} brandArr={brandArr} />
            </Col>
            <Col md={4} className="mx-lg-3 px-lg-3 order-md-1 m-auto">
              <ReactEcharts
                style={{ width: '100%', height: '300px' }}
                className="w-100"
                option={growOption}
              />
              {/* <Doughnut data={doughnutData} options={config.options} /> */}
            </Col>
          </Row>
        </Container>
        <Container className="section2">
          <Row>
            <FanGrowth data={data} title="粉絲成長指標" brandArr={brandArr} />{' '}
          </Row>
        </Container>
        <Container className="section3">
          <Row>
            <AITeacher data={data} title="AI 導師建議" />
          </Row>
        </Container>
      </main>
    </>
  )
}

export default FansComponent
